import * as ActionTypes from './types';

export function openScoreRecordsFilterModal(payload) {
    return {
        type: ActionTypes.OPEN_SCORE_RECORDS_FILTER_MODAL,
        payload: payload
    }
}

export function closeScoreRecordsFilterModal(payload) {
    return {
        type: ActionTypes.CLOSE_SCORE_RECORDS_FILTER_MODAL,
        payload: payload
    }
}

export function filterScoreRecordsLocally(payload) {
    return {
        type: ActionTypes.FILTER_SCORE_RECORDS_LOCALLY,
        payload: payload
    }
}

export function getScoreRecords(payload) {
  return {
    type: ActionTypes.GET_SCORE_RECORDS,
    payload: payload
  }
}

export function getScoreRecordsSuccess(payload) {
  return {
    type: ActionTypes.GET_SCORE_RECORDS_SUCCESS,
    payload: payload
  }
}

export function getScoreRecordsFailed(payload) {
  return {
    type: ActionTypes.GET_SCORE_RECORDS_FAILED,
    payload: payload
  }
}



// WEBPACK FOOTER //
// ./src/actions/scoreRecords.js